import { Box, BoxProps, Container, Grid, Typography } from '@mui/material'

import NewsCard, { type NewsCard as NewsCardProps } from '@/components/base/news-card'
import { useAppStore } from '@/contexts/store'
import { isHappa } from '@/hooks'

import Spacer from './spacer'

export type NewsGridProps = BoxProps &
  Partial<{
    items: (NewsCardProps & { excerpt?: string })[]
  }>

const NewsGrid = ({ items, ...props }: NewsGridProps) => {
  const { strings } = useAppStore()

  return (
    <>
      <Box {...props}>
        <Container>
          <Spacer size="sm" />
          <Typography
            variant="h2"
            color={isHappa ? 'primary.main' : 'text.secondaryContrastText'}
            fontWeight={isHappa ? 700 : 500}
          >
            {strings?.labels?.latest_news}
            <Spacer size="md" />
          </Typography>
          <Grid container>
            {items && items.length > 0 ? (
              items.map(({ excerpt, ...item }, index) => (
                <NewsCard
                  key={`item-${index}`}
                  size={{ xs: 4, sm: 4, md: 3 }}
                  skeleton={false}
                  {...item}
                  text={excerpt || item.text}
                />
              ))
            ) : (
              <Typography variant="textRegular" color="text.secondary">
                {strings?.labels?.no_news || 'Nessuna notizia disponibile'}
              </Typography>
            )}
          </Grid>
          <Spacer size="xl" />
        </Container>
      </Box>
    </>
  )
}

export default NewsGrid
